import React from "react";
import "../IB/IB.css";

const tripData = [
  {
    id: 1,
    title: "Family",
    price: "£326pp",
    description:
      "It's not easy keeping everyone happy on holiday. The Trip Mart is at hand to help you plan the perfect break for all members of your party, from tots to teens to the golden oldies (and everyone else in between).",
    image: "/family.jpg",
  },
  {
    id: 2,
    title: "All Inclusive",
    price: "£482pp",
    description:
      "Take the hassle and worry out of your next beach break, by booking one of our all-inclusive holidays. With meals, drinks, and activities all included, all you need to do is relax and enjoy your holiday!",
    image: "/allex.jpg",
  },
  {
    id: 3,
    title: "Honeymoon",
    price: "£1,165pp",
    description:
      "The start of your journey as a married couple, your honeymoon is the most important holiday of your life. Let the Trip Mart plan every detail of the ultimate romantic getaway.",
    image: "/honey.jpg",
  },
  {
    id: 4,
    title: "Luxury",
    price: "£523pp",
    description:
      "There's something for everyone with our selection of luxury holidays. We have hand-picked some of the best five-star hotels & resorts from around the world.",
    image: "/luxury.jpg",
  },
];

const IB = () => {
  return (
    <section className="ib-section">
      <h1>Holiday Trips to Suit Your Interests and Budget</h1>
      <p className="ib-p">
        Everyone has their own idea about what makes a trip really special. At The Trip Mart we pay special attention to the things that matter most to you, creating tailor-made packages you'll love!
      </p>
      <div className="grid-container">
        {tripData.map((trip, index) => (
          <div
            key={trip.id}
            className={`card ${index >= 2 ? 'card-reverse' : ''}`}
          >
            <img src={trip.image} alt={trip.title} className="card-image" />
            <div className="card-text">
              <h3>{trip.title}</h3>
              <p className="price">from <strong>{trip.price}</strong></p>
              <p>{trip.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default IB;
